export const azimuthThrusterIdNumbers = [
	{
		name: 'BOW_THRUSTER',
		identityNumber: [
			{ value: 1, viewValue: 'T1' },
			{ value: 3, viewValue: 'T3' },
			{ value: 5, viewValue: 'T5' },
		]
	},
	{
		name: 'STERN_THRUSTER',
		identityNumber: [
			{ value: 2, viewValue: 'T2' },
			{ value: 4, viewValue: 'T4' },
			{ value: 6, viewValue: 'T6' },
		]
	}
]

export const THRUSTER_RESPONSE_SOURCE_SELECTOR = 'SG:TRD';
export const THRUSTER_DEMAND_SOURCE_SELECTOR = 'SG:TRC';
